//TOPへ戻るボタン(クリック時の挙動)
$(function(){
  $('.c-btn__toTop').on('click', function () {
    $('body,html').animate({
    scrollTop: 0
    }, 400);
    return false;
  });
});
